import { render, staticRenderFns } from "./SidebarPanel.vue?vue&type=template&id=361ac602&scoped=true&"
import script from "./SidebarPanel.vue?vue&type=script&lang=js&"
export * from "./SidebarPanel.vue?vue&type=script&lang=js&"
import style0 from "./SidebarPanel.vue?vue&type=style&index=0&id=361ac602&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361ac602",
  null
  
)

export default component.exports